import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import * as widgetsActions from "../../../../redux/Widgets/actions";
import GaugeComponent from 'react-gauge-component';
import {
	formatLargeNumber,
	formatLargeNumberToMoney,
} from "../../../../utils/general.js";
import ViewReportLink from "../ViewReportLink.js";
import LoadingStep from "../../../../components/LoadingStep/index.js";

const widgetName = "ClosedWon";

const ClosedWon = props => {
	const widget = useSelector(state => state.widget).widgets[widgetName];
	const user = useSelector(state => state.user.user);
	const dispatch = useDispatch();

	useEffect(() => {
		const load = async () => {
			await dispatch(widgetsActions.loadWidget(widgetName))
		};
		load();
	}, [user]);

	const loading = widget == null || widget.status === "loading" || widget.data == null || widget.data.data == null ;

	if(loading) {
		return (
			<div className="widget-container">
			<div className="widget-title">Loading</div>
			<LoadingStep />
		</div>
		)
	}

	let result = 0;
	widget.data.data.forEach(d => result += d.Amount);

	const number = formatLargeNumber(result);
	const label = formatLargeNumberToMoney(result);

	return (
		<div className="widget-container">
			<div className="widget-title">Closed Won Opportunities ({label})</div>
			<GaugeComponent
				type="radial"
				style={{width: 380, height: '100%'}}
				arc={{
					width: 0.13,
					padding: 0,
					cornerRadius: 1,
					subArcs: [
						{ limit: 10, color: '#FF9416', showTick: true },
						{ limit: 20, color: '#FF9416', showTick: true },

						{ limit: 30, color: '#40A0C1', showTick: true },
						{ limit: 40, color: '#40A0C1', showTick: true },

						{ limit: 50, color: '#dbfaff', showTick: true },
						{ limit: 60, color: '#dbfaff', showTick: true }
					]
				}}
				pointer={{
					color: '#345243',
					length: 0.80,
					width: 15,
					// elastic: true,
				}}
				labels={{
					valueLabel: {
						formatTextValue: value => label,
						style: {fontSize: "20px", fill: "#000"}
					},
					tickLabels: {
						type: 'inner',
						defaultTickValueConfig: {
							style: {fontSize: "12px", fill: "#86909C", textShadow: 'none'}
						},
						defaultTickLineConfig: {
							style: {fontSize: "14px", fill: "#86909C", textShadow: 'none'}
						}
					},
					markLabel: {
						type: 'inner',
					}
				}}
				value={number}
				minValue={0}
				maxValue={60}
			/>
			<ViewReportLink onClick={() => props.showReport(widget)} />
		</div>
	)
};

export default ClosedWon;